"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Card = _interopRequireDefault(require("../../Card/Card"));
var _Link = _interopRequireDefault(require("../../Link/Link"));
var _ComponentWrapper = _interopRequireDefault(require("../../helpers/ComponentWrapper"));
var _currency = require("../../../currency");
var FlexPriceCard = function FlexPriceCard(_ref) {
  var title = _ref.title,
    cta = _ref.cta,
    image = _ref.image,
    text = _ref.text;
  return /*#__PURE__*/_react["default"].createElement(_ComponentWrapper["default"], {
    className: "max-width-xs"
  }, /*#__PURE__*/_react["default"].createElement(_Card["default"], {
    template: "ImageCard",
    imageCardTemplate: "Basic",
    size: "xs",
    bgImage: image || '',
    whiteFont: image,
    overlay: image
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-component"
  }, title && /*#__PURE__*/_react["default"].createElement("h2", {
    className: "d8-u-color-white"
  }, title), text && /*#__PURE__*/_react["default"].createElement("h2", {
    className: "d8-u-color-white"
  }, text), /*#__PURE__*/_react["default"].createElement(_Link["default"], {
    href: cta.url,
    className: "btn btn--transparent margin-top-md margin-bottom-lg"
  }, cta.price && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "from ", /*#__PURE__*/_react["default"].createElement(_currency.FormatCurrency, {
    amount: cta.price,
    baseCurrency: "EUR"
  })), cta.text))));
};
FlexPriceCard.propTypes = {
  title: _propTypes["default"].string,
  text: _propTypes["default"].string,
  cta: _propTypes["default"].object,
  image: _propTypes["default"].object
};
var _default = exports["default"] = FlexPriceCard;